import { Img } from 'component/Image'
import { Space } from 'component/Space/Space'
import { Typo } from 'component/Typo/Typo'
import { observer } from 'mobx-react-lite'
import { ImageStore } from 'page/tryon/store/ImageStore'
import css from './ImageCard.module.scss'

type Props = {
  image: ImageStore | undefined
}

export const ImageCard = observer(({ image }: Props) => {
  const { source, state } = image ?? {}
  const error = state === 'error'
  const good = !!source && !error
  const cross = '\u{1F7AA}'

  if (good) return <Space round wide>
    <Img className={css.image} src={source} alt="" />
  </Space>

  return <Space tall wide center>
    <Typo size={20} tertiary>{cross}</Typo>
  </Space>
})
